import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { PurchaseProjectionModel } from 'src/app/models/preliminaries/purchase-projection.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PurchaseProjectionService {

  private readonly _httpClient = inject(HttpClient);

  createPurchaseProjection(purchaseProjectionModel: PurchaseProjectionModel): Observable<PurchaseProjectionModel> {
    return this._httpClient.post<PurchaseProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseProjection.CreateAsync}`,
      purchaseProjectionModel);
  }

  deletePurchaseProjection(purchaseProjectionId: number): Observable<PurchaseProjectionModel> {
    const params = new HttpParams().set('purchaseProjectionId', purchaseProjectionId);
    return this._httpClient.delete<PurchaseProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseProjection.DeleteAsync}`,
      { params: params });
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseProjection.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllPurchaseProjectionsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseProjection.GetAllPurchaseProjectionsWithPaginationAsync}`,
      filters, { params: params });
  }

  getArticlesForSelect(): Observable<Array<CustomListDropdown>> {
    return this._httpClient.get<Array<CustomListDropdown>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseProjection.GetArticlesForSelectAsync}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseProjection.GetColumnsForGeneralConsultationAsync}`);
  }

  getPurchaseProjectionById(purchaseProjectionId: number): Observable<PurchaseProjectionModel> {
    const params = new HttpParams().set('purchaseProjectionId', purchaseProjectionId);
    return this._httpClient.get<PurchaseProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseProjection.GetByIdAsync}`,
      { params: params });
  }

  getPurchaseProjectionByKeys(branchId: number, articleId: number): Observable<PurchaseProjectionModel> {
    const params = new HttpParams().set('branchId', branchId).set('articleId', articleId);
    return this._httpClient.get<PurchaseProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseProjection.GetPurchaseProjectionByKeysAsync}`,
      { params: params }
    );
  }

  updatePurchaseProjection(purchaseProjectionModel: PurchaseProjectionModel): Observable<PurchaseProjectionModel> {
    return this._httpClient.put<PurchaseProjectionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseProjection.UpdateAsync}`,
      purchaseProjectionModel
    );
  }
}
